let data = JSON.parse(sessionStorage.getItem('physician-sign-up-data') || '{}')

export default {
  data,
}
